// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__CNg9p","amount":"Amount_amount__3eFrP","tip":"Amount_tip__1D7eG","tipHeader":"Amount_tipHeader__wOAdy","tipsWrap":"Amount_tipsWrap__3xfGz"};